import React from "react";

const TermsOfService = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-xl mt-10">
      <h1 className="text-3xl font-bold mb-4 text-gray-800">Terms of Service</h1>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">Overview</h2>
      <p className="text-gray-700 mb-4">
        This website is operated by <strong>Gerado</strong>. Throughout the site, the terms "we", "us", and "our" refer to Gerado. Gerado offers this website, including all
        information, tools, and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies, and
        notices stated here.
      </p>

      <p className="text-gray-700 mb-4">
        By visiting our site and/or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions
        (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink.
        These Terms of Service apply to all users of the site, including without limitation browsers, vendors, customers, merchants, and content contributors.
      </p>

      <p className="text-gray-700 mb-4">
        Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound
        by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any
        services.
      </p>

      <p className="text-gray-700 mb-4">
        Any new features or tools added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service
        at any time on this page. We reserve the right to update, change, or replace any part of these Terms by posting updates to our website. Your continued use of
        the website after changes constitutes acceptance.
      </p>
      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">SECTION 1 - Online Store Terms</h2>
      <p className="text-gray-700 mb-4">
        By agreeing to these Terms, you represent that you are at least the age of majority in your jurisdiction, or have given consent for any minor dependents
        to use this site. You must not transmit any worms or viruses or any code of a destructive nature. A breach will result in immediate termination.
      </p>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">SECTION 2 - General Conditions</h2>
      <p className="text-gray-700 mb-4">
        We reserve the right to refuse service to anyone at any time. You may not use our products for illegal or unauthorized purposes or violate any laws in your jurisdiction.
      </p>

      <p className="text-gray-700 mb-4">
        Your content (excluding credit card info) may be transferred unencrypted and involve changes to meet technical requirements. Credit card info is always encrypted.
      </p>

      <p className="text-gray-700 mb-4">
        You agree not to reproduce, duplicate, copy, sell, resell, or exploit any part of the service without our express written permission.
      </p>

      <p className="text-gray-700 mb-4">
        Headings used in this agreement are for convenience and do not affect these Terms.
      </p>

      <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-2">SECTION 20 - Contact Information</h2>
      <p className="text-gray-700 mb-4">
        Questions about the Terms of Service should be sent to us at{" "}
        <a href="mailto:garadofashion@gmail.com" className="text-blue-600 underline">
          garadofashion@gmail.com
        </a>.
      </p>

      <p className="text-gray-700">
        <strong>Gerado</strong>
        <br />
        <a href="mailto:geradofashion@gmail.com" className="text-blue-600 underline">
          geradofashion@gmail.com
        </a>
      </p>
    </div>
  );
};

export default TermsOfService;
